document.addEventListener('DOMContentLoaded', () => {
    // Use event delegation to handle clicks on .new-share-icon elements
    document.addEventListener('click', function(event) {
        if (event.target.closest('.new-share-icon')) {
            event.preventDefault(); // Prevent the default anchor behavior

            const icon = event.target.closest('.new-share-icon');
            const clickToCopy = document.querySelector('.csr-popup .click_to_copy');

            if (!clickToCopy) {
                console.error('.click_to_copy not found or null');
                return;
            }
            const csrPopup = document.querySelector('.csr-popup');
            console.log(csrPopup);
            if (csrPopup) {
                csrPopup.classList.add('active');
            }


            const hrefValue = icon.getAttribute('href');
            clickToCopy.setAttribute('href', hrefValue);
        }
    });
    // remove active class 
    const popupot = document.querySelectorAll('.share_popup_container .custom_popup_close');
    popupot.forEach(button => {
        button.addEventListener('click', () => {
            const csrPopup = document.querySelector('.csr-popup');
           const shareIconbg = document.querySelector('.csr-popup .share-item .share-icon');
            if (csrPopup) {
                csrPopup.classList.remove('active');
               shareIconbg.style.backgroundColor = '#4B7BBF';
              
            }
        });
    });
});